<div class="fade-in container">
	<div class="list-container">
		<div class="search-wrapper fade-in">
			<app-search-form (onSubmit)="onSearchFormSubmit$($event)"></app-search-form>
		</div>

		<div class="pagination-wrapper fade-in">
			<nz-pagination
				[nzPageIndex]="currentPage()"
				[nzPageSize]="LOCATIONS_PAGE_SIZE"
				[nzTotal]="totalLocations()"
				(nzPageIndexChange)="onPageChange($event)"
			></nz-pagination>
			<br />
		</div>

		<app-list
			[enableSelect]="true"
			[enableUpDown]="true"
			[enableCopy]="false"
			[enableEdit]="true"
			[enableDelete]="true"
			[items]="locations()"
			itemUuidName="locationUuid"
			[selectedUuid]="editLocation()?.uuid"
			prefix="LOCATION"
			(onSelect)="select($event)"
			(onEdit)="edit($event)"
			(onDelete)="delete$($event)"
			(onMoveUp)="moveUp$($event)"
			(onMoveDown)="moveDown$($event)"
		>
			<ng-template let-item>
				<div>{{ item.name }}</div>
			</ng-template>
		</app-list>
	</div>

	<div class="form-container">
		<nz-card>
			<app-location-form
				[location]="editLocation()"
				[loading]="loading()"
				(onSubmit)="onLocationFormSubmit$($event)"
			></app-location-form>
		</nz-card>
	</div>
</div>
